import { useContext } from 'react';
import { ViewerBinaryCacheContext } from './ViewerBinaryCacheContext';

export function useViewerBinaryCache() {
    const viewerBinaryCache = useContext(ViewerBinaryCacheContext);

    if (!viewerBinaryCache) {
        throw new Error('useViewerBinaryCache must be used within a ViewerBinaryCacheProvider.');
    }

    return viewerBinaryCache;
}

export function getCaseViewerBinaryScopeId(caseId) {
    return caseId == null || caseId === '' ? null : `case:${caseId}`;
}
